export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  /** 可选:显式链接(用于首页等 name 与路径不一致的项) */
  link?: string
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'home',
      displayName: 'menu.home',
      link: '/',
      meta: {
        icon: 'home',
      },
    },
    {
      name: 'seo-nav',
      displayName: 'menu.seo-nav',
      meta: {
        icon: 'travel_explore',
      },
    },
    {
      name: 'geo-nav',
      displayName: 'menu.geo-nav',
      meta: {
        icon: 'auto_awesome',
      },
    },
    {
      name: 'aeo-nav',
      displayName: 'menu.aeo-nav',
      meta: {
        icon: 'question_answer',
      },
    },
    {
      name: 'llms-txt',
      displayName: 'menu.llms-txt',
      meta: {
        icon: 'description',
      },
    },
    {
      name: 'ai-checker',
      displayName: 'menu.ai-checker',
      meta: {
        icon: 'health_and_safety',
      },
    },
    {
      name: 'glossary',
      displayName: 'menu.glossary',
      meta: {
        icon: 'menu_book',
      },
    },
    {
      name: 'schema-generator',
      displayName: 'menu.schema-generator',
      meta: {
        icon: 'data_object',
      },
    },
    {
      name: 'domain-namer',
      displayName: 'menu.domain-namer',
      meta: {
        icon: 'dns',
      },
      children: [
        { name: 'domain-namer', displayName: 'menu.domain-namer-naming', meta: { icon: 'dns' } },
        { name: 'domain-namer/autofill', displayName: 'menu.domain-namer-autofill', meta: { icon: 'auto_mode' } },
        { name: 'domain-namer/rank', displayName: 'menu.domain-namer-rank', meta: { icon: 'leaderboard' } },
      ],
    },
    {
      name: 'articles',
      displayName: 'menu.articles',
      meta: {
        icon: 'article',
      },
    },
    {
      name: 'tutorials',
      displayName: 'menu.tutorials',
      meta: {
        icon: 'school',
      },
    },
    {
      name: 'news',
      displayName: 'menu.news',
      meta: {
        icon: 'newspaper',
      },
    },
    {
      name: 'backlinks',
      displayName: 'menu.backlinks',
      meta: {
        icon: 'link',
      },
    },
  ] as INavigationRoute[],
}
